import { BDropdownText } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBDropdownText when migrating. */
export const EgBDropdownText = createEgBootstrapProxy(
  "EgBDropdownText",
  BDropdownText
);
